"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var VIDEO_TYPES = ['1 Person Interview', '2 Person Interview', 'Piece to Camera', 'Visual Story', 'Tutorial', 'Event Video'];

function DetailsTab(_ref) {
  var handleStoryboardFieldChange = _ref.handleStoryboardFieldChange,
      storyboard = _ref.storyboard,
      hasUpdatePermission = _ref.hasUpdatePermission;
  var videoType = storyboard.videoType,
      objectives = storyboard.objectives,
      targetAudience = storyboard.targetAudience,
      keyMessage = storyboard.keyMessage,
      callToAction = storyboard.callToAction,
      duration = storyboard.duration,
      platforms = storyboard.platforms,
      mood = storyboard.mood,
      music = storyboard.music,
      videoStyle = storyboard.videoStyle;
  return _react.default.createElement("div", {
    className: "storyboard-tab"
  }, _react.default.createElement(_uiKit.Accordion, {
    titles: ['Basic Details', 'Output', 'References']
  }, _react.default.createElement("div", {
    className: "details__panel"
  }, _react.default.createElement(_uiKit.Dropdown, {
    className: "details__panel__input",
    label: "Video Type",
    defaultValue: videoType,
    options: VIDEO_TYPES,
    onChange: handleStoryboardFieldChange('videoType'),
    disabled: !hasUpdatePermission,
    placeholder: "What type of video is this?",
    fontSize: 12,
    fontColor: "red"
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Objectives",
    defaultValue: objectives,
    onChange: handleStoryboardFieldChange('objectives'),
    multiline: true,
    placeholder: "What is the intent of this video?",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Target Audience",
    defaultValue: targetAudience,
    onChange: handleStoryboardFieldChange('targetAudience'),
    placeholder: "Who is this video intended for?",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Key Message",
    defaultValue: keyMessage,
    onChange: handleStoryboardFieldChange('keyMessage'),
    multiline: true,
    placeholder: "What is the key message?",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Call-To-Action",
    defaultValue: callToAction,
    onChange: handleStoryboardFieldChange('callToAction'),
    placeholder: "What do you want viewers to do?",
    disabled: !hasUpdatePermission
  })), _react.default.createElement("div", {
    className: "details__panel"
  }, _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Duration",
    defaultValue: duration,
    onChange: handleStoryboardFieldChange('duration'),
    placeholder: "How long is this video intended?",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Platforms",
    defaultValue: platforms,
    onChange: handleStoryboardFieldChange('platforms'),
    placeholder: "Where is this being shared?",
    disabled: !hasUpdatePermission
  })), _react.default.createElement("div", {
    className: "details__panel"
  }, _react.default.createElement(_uiKit.TagInput, {
    label: "Mood",
    defaultValue: mood,
    onChange: handleStoryboardFieldChange('mood'),
    placeholder: "Add some tags for mood",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Music",
    defaultValue: music,
    onChange: handleStoryboardFieldChange('music'),
    multiline: true,
    placeholder: "Add some music references",
    disabled: !hasUpdatePermission
  }), _react.default.createElement(_uiKit.Input, {
    className: "details__panel__input",
    label: "Video Style",
    defaultValue: videoStyle,
    onChange: handleStoryboardFieldChange('videoStyle'),
    multiline: true,
    placeholder: "Add some style references",
    disabled: !hasUpdatePermission
  }))));
}

var _default = DetailsTab;
exports.default = _default;